import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem/SliderListItem';

const BackdropMotionBlurSlider = (props) => {
    const { motionBlurIntensity, updateBackgroundSettings } = props;

    const onMotionBlurChange = useCallback((value) => {
        if (value === motionBlurIntensity) return;
        updateBackgroundSettings({ motionBlurIntensity: value });
    }, [motionBlurIntensity, updateBackgroundSettings]);

    return (
        <SliderListItem
            title='Motion Blur'
            displayMultiplier={1}
            value={motionBlurIntensity}
            min={0}
            max={100}
            step={1}
            onValueChange={onMotionBlurChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { motionBlurIntensity } = state.createPreview.present.videoSettings.background;
    return {
        motionBlurIntensity: motionBlurIntensity ?? 20
    };
};

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings };
};

export default connect(mapStateToProps, mapDispatchToProps)(BackdropMotionBlurSlider);
